import React, { useCallback, useMemo } from "react";
import { DA_Icon, DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { useBasket } from "@danishagro/shared/src/contexts/basket/basket.context";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { formatNumber } from "@danishagro/shared/src/helpers/formatNumber.helper";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import S from "./FreeDelivery.module.scss";

interface FreeDeliveryProps {
    marginSpace?: boolean;
}

export const FreeDelivery = ({ marginSpace }: FreeDeliveryProps) => {
    const { getDictionaryString } = useTranslations();

    const { priceData } = useBasket();
    const { currentCulture } = useAppData();

    const showInitialMessage = useMemo(
        () => !globalThis?.isAuthenticated && priceData === undefined,
        [priceData]
    );

    const isFreeShippingReached = priceData?.amountUntilFreeShipping === 0;

    const formatPrice = useCallback(
        (price: number) => formatNumber(price, currentCulture, { decimals: 2 }),
        [currentCulture]
    );

    return (
        <div
            className={cn(
                S.freeDeliveryWrapper,
                isFreeShippingReached && S.freeShippingReached,
                marginSpace && S.marginSpace
            )}
        >
            <DA_Icon className={S.deliveryIcon} name={DA_IconNames.Delivery} />
            {showInitialMessage ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: getDictionaryString("pdp.freeDeliveryInitial"),
                    }}
                />
            ) : isFreeShippingReached ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: getDictionaryString("pdp.freeDeliveryReached"),
                    }}
                />
            ) : (
                <span
                    dangerouslySetInnerHTML={{
                        __html: getDictionaryString("pdp.freeDelivery", {
                            price: formatPrice(priceData?.amountUntilFreeShipping),
                        }),
                    }}
                />
            )}
        </div>
    );
};
